<template>
    <div>
        <NavBar />

        <div class="container mx-auto">
            <header>
                <div class="max-w-7xl mx-auto py-6 px-4 sm:px-6 lg:px-8">
                    <h1 class="text-3xl font-bold leading-tight text-gray-900">
                        Create Caller
                    </h1>
                </div>
            </header>
        </div>

        <div class="container mx-auto">
            <div class="max-w-full mx-auto sm:px-6 lg:px-8">
                <div class="px-4 py-6 sm:px-0">
                    <form class="w-full max-w-lg" @submit.prevent="createCaller">
                        <div class="flex flex-wrap -mx-3">
                            <div class="w-full px-3 mb-6 md:mb-0">
                                <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="grid-first-name">
                                    Name
                                </label>
                                <input class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white" id="grid-first-name" type="text" placeholder="Jane" v-model="callerName" required />
                            </div>
                        </div>
                        <div class="flex flex-wrap -mx-3 mb-6">
                            <div class="w-full px-3 mb-6 md:mb-0">
                                <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="grid-phone-number">
                                    Phone Number
                                </label>
                                <input
                                    v-model="phone_number"
                                    type="tel"
                                    pattern="[0-9]{10}"
                                    class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white" id="grid-phone-number" placeholder="0412345678" required />
                            </div>

                            <div class="w-full px-3 mb-6 md:mb-0">
                                <label class="block uppercase tracking-wide text-gray-700 text-xs font-bold mb-2" for="grid-company">
                                    Company
                                </label>
                                <input
                                    v-model="company"
                                    class="appearance-none block w-full bg-gray-200 text-gray-700 border rounded py-3 px-4 mb-3 leading-tight focus:outline-none focus:bg-white" id="grid-company" type="text" placeholder="Acme Corporation" required />
                            </div>
                        </div>
                        <button class="bg-green-500 hover:bg-green-700 text-white font-bold text-sm py-3 px-4 shadow rounded"> Create </button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import NavBar from "../components/NavBar";
import { api } from "../store/http";

export default {
    name: "CreateCaller",
    components: {
        NavBar,
    },
    data() {
        return {
            callerName: "",
            company: "",
            phone_number: "",
        }
    },
    methods: {
        createCaller(e) {
            const data = new FormData();

            data.append("create_caller_request[name]", this.callerName);
            data.append("create_caller_request[phone_number]", this.phone_number);
            data.append("create_caller_request[company_name]", this.company);

            api.post("callers", data)
                .then(response => {
                    alert("Done!")
                })
            ;
        }
    }
}
</script>